import { jsx, css } from "@emotion/react";

export default {
  smallBoldHigh: css`
    font-size: 12px;
    font-weight: 700;
    line-height: 32px;
  `,
  verySmallRegular: css`
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
  `,
  smallRegular: css`
    font-size: 12px;
    font-weight: 500;
    /* letter-spacing: .04em; */
    line-height: 16px;
    /* margin: 16px 0 8px; */
    /* text-transform: uppercase; */
  `,
  smallUpperCase: css`
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.04em;
    line-height: 16px;
    text-transform: uppercase;
  `,
};
